import { render, staticRenderFns } from "./customerEdit.vue?vue&type=template&id=6449c72c&scoped=true&"
import script from "./customerEdit.vue?vue&type=script&lang=js&"
export * from "./customerEdit.vue?vue&type=script&lang=js&"
import style0 from "./customerEdit.vue?vue&type=style&index=0&id=6449c72c&lang=less&scoped=true&"
import style1 from "./customerEdit.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6449c72c",
  null
  
)

component.options.__file = "customerEdit.vue"
export default component.exports